export default [
  {
    id: '4bba1741-ef26-4708-baf7-494d21fac1f9', // id 全局唯一，终身制
    path: '/wiz-iot-management',
    name: 'wizIotManagement',
    meta: { title: '物联网系统' },
    // layout: 'default',
    // 根菜单不需要定义 component，由主框架定义
    children: [
      {
        id: 'b4055768-1c2a-4a9f-93d2-a2506e4844ca', // id 全局唯一，终身制
        path: 'basic-setting',
        name: 'basicSetting',
        meta: { title: '基础设置' },
        children: [
          {
            id: '618d97af-f170-44df-b17f-ad414188413d',
            path: 'access-template',
            name: 'accessTemplate',
            component: () => {
              return import('./views/basic-setting/access-template/index')
            },
            meta: {
              title: '接入模板管理',
              operations: {
                create: {
                  id: 0,
                  name: 'create',
                  desc: '新增',
                  access: true,
                },
                read: {
                  id: 1,
                  name: 'read',
                  desc: '详情',
                  access: true,
                  group: 'read',
                },
                update: {
                  id: 2,
                  name: 'update',
                  desc: '修改',
                  access: true,
                },
                delete: {
                  id: 3,
                  name: 'delete',
                  desc: '删除',
                  access: true,
                },
              },
            },
          },
        ],
      },
      {
        id: '230999ba-76a0-483a-bd09-d8241fa2a6ed', // id 全局唯一，终身制
        path: 'monitor-manage',
        name: 'monitorManage',
        meta: { title: '摄像头管理' },
        children: [
          {
            id: 'e3360694-21c2-4595-906f-6a39fc858712',
            path: 'monitor-protocol',
            name: 'monitorProtocol',
            component: () => {
              return import('./views/monitor-manage/monitor-protocol/index')
            },
            meta: {
              title: '摄像头协议',
              operations: {
                create: {
                  id: 0,
                  name: 'create',
                  desc: '新增',
                  access: true,
                },
                read: {
                  id: 1,
                  name: 'read',
                  desc: '详情',
                  access: true,
                  group: 'read',
                },
                update: {
                  id: 2,
                  name: 'update',
                  desc: '修改',
                  access: true,
                },
                delete: {
                  id: 3,
                  name: 'delete',
                  desc: '删除',
                  access: true,
                },
              },
            },
          },
          {
            id: 'c1ef6718-927d-4f2b-90d9-55d4ed80da2e',
            path: 'monitor-linkin',
            name: 'monitorLinkin',
            component: () => {
              return import('./views/monitor-manage/monitor-linkin/index')
            },
            meta: {
              title: '摄像头接入',
              operations: {
                create: {
                  id: 0,
                  name: 'create',
                  desc: '新增',
                  access: true,
                },
                read: {
                  id: 1,
                  name: 'read',
                  desc: '详情',
                  access: true,
                  group: 'read',
                },
                update: {
                  id: 2,
                  name: 'update',
                  desc: '修改',
                  access: true,
                },
                delete: {
                  id: 3,
                  name: 'delete',
                  desc: '删除',
                  access: true,
                },
              },
            },
          },
          {
            id: 'f5760d0c-705a-4f8d-9222-161c7091d016',
            path: 'monitorList',
            name: 'monitorList',
            component: () => {
              return import('./views/monitor-manage/monitor-list/index')
            },
            meta: {
              title: '摄像头清单',
              operations: {
                create: {
                  id: 0,
                  name: 'create',
                  desc: '新增',
                  access: true,
                },
                read: {
                  id: 1,
                  name: 'read',
                  desc: '详情',
                  access: true,
                  group: 'read',
                },
                update: {
                  id: 2,
                  name: 'update',
                  desc: '修改',
                  access: true,
                },
                delete: {
                  id: 3,
                  name: 'delete',
                  desc: '删除',
                  access: true,
                },
              },
            },
          },
          {
            id: '3d0085a3-b4df-4125-902f-f3b041e6b762',
            path: 'real-time-monitor',
            name: 'realTimeMonitor',
            component: () => {
              return import('./views/monitor-manage/real-time-monitor/index')
            },
            meta: {
              title: '实时监控',
            },
          },
          {
            id: 'c1ceefaf-3f31-4e45-a6bc-3a0e4fbf074b',
            path: 'cameraLocation',
            name: 'cameraLocation',
            component: () => {
              return import('./views/monitor-manage/monitor-location-setting/index')
            },
            meta: {
              title: '设备位置设置',
              hidden: true,
              tabnab: false,
              operations: {
                create: {
                  id: 0,
                  name: 'create',
                  desc: '新增',
                  access: true,
                },
                read: {
                  id: 1,
                  name: 'read',
                  desc: '详情',
                  access: true,
                  group: 'read',
                },
                update: {
                  id: 2,
                  name: 'update',
                  desc: '修改',
                  access: true,
                },
                delete: {
                  id: 3,
                  name: 'delete',
                  desc: '删除',
                  access: true,
                },
              },
            },
          },
        ],
      },
      {
        id: '9c1e6d94-266f-475a-a719-4e872914d481', // id 全局唯一，终身制
        path: 'access-control-manage',
        name: 'accessControlManage',
        meta: { title: '门禁管理' },
        children: [
          {
            id: 'b6795bc2-27b4-4b58-8330-cbfc00160861',
            path: 'access-control-protocol',
            name: 'accessControlProtocol',
            component: () => {
              return import('./views/access-control-manage/access-control-protocol/index')
            },
            meta: {
              title: '门禁协议',
              operations: {
                create: {
                  id: 0,
                  name: 'create',
                  desc: '新增',
                  access: true,
                },
                read: {
                  id: 1,
                  name: 'read',
                  desc: '详情',
                  access: true,
                  group: 'read',
                },
                update: {
                  id: 2,
                  name: 'update',
                  desc: '修改',
                  access: true,
                },
                delete: {
                  id: 3,
                  name: 'delete',
                  desc: '删除',
                  access: true,
                },
              },
            },
          },
          {
            id: 'c94a4b65-2652-4ab3-9f3b-9006ab902626',
            path: 'access-control-linkin',
            name: 'accessControlLinkin',
            component: () => {
              return import('./views/access-control-manage/access-control-linkin/index')
            },
            meta: {
              title: '门禁接入',
              operations: {
                create: {
                  id: 0,
                  name: 'create',
                  desc: '新增',
                  access: true,
                },
                read: {
                  id: 1,
                  name: 'read',
                  desc: '详情',
                  access: true,
                  group: 'read',
                },
                update: {
                  id: 2,
                  name: 'update',
                  desc: '修改',
                  access: true,
                },
                delete: {
                  id: 3,
                  name: 'delete',
                  desc: '删除',
                  access: true,
                },
              },
            },
          },
          {
            id: 'eeb661d4-f307-424b-9e48-c094c1d46a82',
            path: 'access-control-list',
            name: 'accessControlList',
            component: () => {
              return import('./views/access-control-manage/access-control-list/index')
            },
            meta: {
              title: '门禁清单',
              operations: {
                create: {
                  id: 0,
                  name: 'create',
                  desc: '新增',
                  access: true,
                },
                read: {
                  id: 1,
                  name: 'read',
                  desc: '详情',
                  access: true,
                  group: 'read',
                },
                update: {
                  id: 2,
                  name: 'update',
                  desc: '修改',
                  access: true,
                },
                delete: {
                  id: 3,
                  name: 'delete',
                  desc: '删除',
                  access: true,
                },
              },
            },
          },
          {
            id: '53a1f913-f59a-4708-a6ae-d8254fa212a6',
            path: 'access-control-redord',
            name: 'accessControlRecord',
            component: () => {
              return import('./views/access-control-manage/access-control-record/index')
            },
            meta: {
              title: '人员出入记录',
              operations: {
                create: {
                  id: 0,
                  name: 'create',
                  desc: '新增',
                  access: true,
                },
                read: {
                  id: 1,
                  name: 'read',
                  desc: '详情',
                  access: true,
                  group: 'read',
                },
                update: {
                  id: 2,
                  name: 'update',
                  desc: '修改',
                  access: true,
                },
                delete: {
                  id: 3,
                  name: 'delete',
                  desc: '删除',
                  access: true,
                },
              },
            },
          },
          {
            id: '1efd006f-841f-4281-ad99-769688bf0ff1',
            path: 'person-statistics-panel',
            name: 'personStatisticsPanel',
            component: () => {
              return import('./views/access-control-manage/person-statistics-panel/index')
            },
            meta: {
              title: '人员统计面板',
              operations: {
                create: {
                  id: 0,
                  name: 'create',
                  desc: '新增',
                  access: true,
                },
                read: {
                  id: 1,
                  name: 'read',
                  desc: '详情',
                  access: true,
                  group: 'read',
                },
                update: {
                  id: 2,
                  name: 'update',
                  desc: '修改',
                  access: true,
                },
                delete: {
                  id: 3,
                  name: 'delete',
                  desc: '删除',
                  access: true,
                },
              },
            },
          },
        ],
      },
      {
        id: '387800a4-9039-4bdf-b25e-cf0205f0c7ec', // id 全局唯一，终身制
        path: 'barrier-gate-manage',
        name: 'barrierGateManage',
        meta: { title: '道闸管理' },
        children: [
          {
            id: '0b3633ab-dfb7-444f-b37b-19acab05c0b6',
            path: 'barrier-gate-protocol',
            name: 'barrierGateProtocol',
            component: () => {
              return import('./views/barrier-gate-manage/barrier-gate-protocol/index')
            },
            meta: {
              title: '道闸协议',
              operations: {
                create: {
                  id: 0,
                  name: 'create',
                  desc: '新增',
                  access: true,
                },
                read: {
                  id: 1,
                  name: 'read',
                  desc: '详情',
                  access: true,
                  group: 'read',
                },
                update: {
                  id: 2,
                  name: 'update',
                  desc: '修改',
                  access: true,
                },
                delete: {
                  id: 3,
                  name: 'delete',
                  desc: '删除',
                  access: true,
                },
              },
            },
          },
          {
            id: '879e1680-6e7f-497d-9263-cf513ce8c0af',
            path: 'barrier-gate-linkin',
            name: 'barrierGateLinkin',
            component: () => {
              return import('./views/barrier-gate-manage/barrier-gate-linkin/index')
            },
            meta: {
              title: '道闸接入',
              operations: {
                create: {
                  id: 0,
                  name: 'create',
                  desc: '新增',
                  access: true,
                },
                read: {
                  id: 1,
                  name: 'read',
                  desc: '详情',
                  access: true,
                  group: 'read',
                },
                update: {
                  id: 2,
                  name: 'update',
                  desc: '修改',
                  access: true,
                },
                delete: {
                  id: 3,
                  name: 'delete',
                  desc: '删除',
                  access: true,
                },
              },
            },
          },
          {
            id: 'a6f8812d-09fc-4549-bcb5-272c59f4b4dd',
            path: 'barrier-gate-list',
            name: 'barrierGateList',
            component: () => {
              return import('./views/barrier-gate-manage/barrier-gate-list/index')
            },
            meta: {
              title: '道闸清单',
              operations: {
                create: {
                  id: 0,
                  name: 'create',
                  desc: '新增',
                  access: true,
                },
                read: {
                  id: 1,
                  name: 'read',
                  desc: '详情',
                  access: true,
                  group: 'read',
                },
                update: {
                  id: 2,
                  name: 'update',
                  desc: '修改',
                  access: true,
                },
                delete: {
                  id: 3,
                  name: 'delete',
                  desc: '删除',
                  access: true,
                },
              },
            },
          },
          {
            id: '1351c1e9-0ee3-49b2-9bd9-a0b424cdc7f1',
            path: 'barrier-gate-redord',
            name: 'barrierGateRecord',
            component: () => {
              return import('./views/barrier-gate-manage/barrier-gate-record/index')
            },
            meta: {
              title: '车辆出入记录',
              operations: {
                create: {
                  id: 0,
                  name: 'create',
                  desc: '新增',
                  access: true,
                },
                read: {
                  id: 1,
                  name: 'read',
                  desc: '详情',
                  access: true,
                  group: 'read',
                },
                update: {
                  id: 2,
                  name: 'update',
                  desc: '修改',
                  access: true,
                },
                delete: {
                  id: 3,
                  name: 'delete',
                  desc: '删除',
                  access: true,
                },
              },
            },
          },
        ],
      },
      {
        id: '01b95e1f-8bea-4eae-ba04-611bc5a9af8f', // id 全局唯一，终身制
        path: 'broadcast-manage',
        name: 'broadcastManage',
        meta: { title: '广播管理' },
        children: [
          {
            id: '59bdc182-4c32-4acf-8a43-072dc0b47043',
            path: 'broadcast-protocol',
            name: 'broadcastProtocol',
            component: () => {
              return import('./views/broadcast-manage/broadcast-protocol/index')
            },
            meta: {
              title: '广播协议',
              operations: {
                create: {
                  id: 0,
                  name: 'create',
                  desc: '新增',
                  access: true,
                },
                read: {
                  id: 1,
                  name: 'read',
                  desc: '详情',
                  access: true,
                  group: 'read',
                },
                update: {
                  id: 2,
                  name: 'update',
                  desc: '修改',
                  access: true,
                },
                delete: {
                  id: 3,
                  name: 'delete',
                  desc: '删除',
                  access: true,
                },
              },
            },
          },
          {
            id: '2758730a-47a0-4411-aa30-7b6c88adf79e',
            path: 'broadcast-linkin',
            name: 'broadcastLinkin',
            component: () => {
              return import('./views/broadcast-manage/broadcast-linkin/index')
            },
            meta: {
              title: '广播接入',
              operations: {
                create: {
                  id: 0,
                  name: 'create',
                  desc: '新增',
                  access: true,
                },
                read: {
                  id: 1,
                  name: 'read',
                  desc: '详情',
                  access: true,
                  group: 'read',
                },
                update: {
                  id: 2,
                  name: 'update',
                  desc: '修改',
                  access: true,
                },
                delete: {
                  id: 3,
                  name: 'delete',
                  desc: '删除',
                  access: true,
                },
              },
            },
          },
          {
            id: '0d5acfea-d596-496f-8bbd-212d4719b8de',
            path: 'broadcast-list',
            name: 'broadcastList',
            component: () => {
              return import('./views/broadcast-manage/broadcast-list/index')
            },
            meta: {
              title: '广播清单',
              operations: {
                create: {
                  id: 0,
                  name: 'create',
                  desc: '新增',
                  access: true,
                },
                read: {
                  id: 1,
                  name: 'read',
                  desc: '详情',
                  access: true,
                  group: 'read',
                },
                update: {
                  id: 2,
                  name: 'update',
                  desc: '修改',
                  access: true,
                },
                delete: {
                  id: 3,
                  name: 'delete',
                  desc: '删除',
                  access: true,
                },
              },
            },
          },
          {
            id: '53a068f4-42a8-4401-a87c-31f821c48619',
            path: 'broadcast-apply',
            name: 'broadcastApply',
            component: () => {
              return import('./views/broadcast-manage/broadcast-apply/index')
            },
            meta: {
              title: '在线广播',
              operations: {
                create: {
                  id: 0,
                  name: 'create',
                  desc: '新增',
                  access: true,
                },
                read: {
                  id: 1,
                  name: 'read',
                  desc: '详情',
                  access: true,
                  group: 'read',
                },
                update: {
                  id: 2,
                  name: 'update',
                  desc: '修改',
                  access: true,
                },
                delete: {
                  id: 3,
                  name: 'delete',
                  desc: '删除',
                  access: true,
                },
              },
            },
          },
        ],
      },
      {
        id: '6ace4db6-02cd-4882-a2d4-8309e6b8197f', // id 全局唯一，终身制
        path: 'fire-fighting-manage',
        name: 'fireFightingManage',
        meta: { title: '消防设备管理' },
        children: [
          {
            id: 'c4745218-a2c3-48f6-86d8-2f42e8cf7c9c',
            path: 'fire-fighting-protocol',
            name: 'fireFightingProtocol',
            component: () => {
              return import('./views/fire-fighting-manage/fire-fighting-protocol/index')
            },
            meta: {
              title: '消防设备协议',
              operations: {
                create: {
                  id: 0,
                  name: 'create',
                  desc: '新增',
                  access: true,
                },
                read: {
                  id: 1,
                  name: 'read',
                  desc: '详情',
                  access: true,
                  group: 'read',
                },
                update: {
                  id: 2,
                  name: 'update',
                  desc: '修改',
                  access: true,
                },
                delete: {
                  id: 3,
                  name: 'delete',
                  desc: '删除',
                  access: true,
                },
              },
            },
          },
          {
            id: '5b5efb59-5707-4659-a9a3-b7fa1056c2ab',
            path: 'fire-fighting-linkin',
            name: 'fireFightingLinkin',
            component: () => {
              return import('./views/fire-fighting-manage/fire-fighting-linkin/index')
            },
            meta: {
              title: '消防设备接入',
              operations: {
                create: {
                  id: 0,
                  name: 'create',
                  desc: '新增',
                  access: true,
                },
                read: {
                  id: 1,
                  name: 'read',
                  desc: '详情',
                  access: true,
                  group: 'read',
                },
                update: {
                  id: 2,
                  name: 'update',
                  desc: '修改',
                  access: true,
                },
                delete: {
                  id: 3,
                  name: 'delete',
                  desc: '删除',
                  access: true,
                },
              },
            },
          },
          {
            id: 'f4497864-707f-4299-8bd9-28745d980c12',
            path: 'fire-fighting-list',
            name: 'fireFightingList',
            component: () => {
              return import('./views/fire-fighting-manage/fire-fighting-list/index')
            },
            meta: {
              title: '消防设备清单',
              operations: {
                create: {
                  id: 0,
                  name: 'create',
                  desc: '新增',
                  access: true,
                },
                read: {
                  id: 1,
                  name: 'read',
                  desc: '详情',
                  access: true,
                  group: 'read',
                },
                update: {
                  id: 2,
                  name: 'update',
                  desc: '修改',
                  access: true,
                },
                delete: {
                  id: 3,
                  name: 'delete',
                  desc: '删除',
                  access: true,
                },
              },
            },
          },
          {
            id: '4ea64e8a-cf59-498e-b0f3-9e682ab8a651',
            path: 'fire-fighting-message',
            name: 'fireFightingMessage',
            component: () => {
              return import('./views/fire-fighting-manage/fire-fighting-message/index')
            },
            meta: {
              title: '消防设备消息',
              operations: {
                read: {
                  id: 1,
                  name: 'read',
                  desc: '详情',
                  access: true,
                  group: 'read',
                },
                delete: {
                  id: 3,
                  name: 'delete',
                  desc: '删除',
                  access: true,
                },
              },
            },
          },
        ],
      },
    ],
  },
]
